import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "./toolBar";
import { AppHelper } from "../../appHelper";
import { IsSearchField, IsSearchFieldField } from "./isSearchField";
import { IsPanelbarDetails } from "./isPanelbarDetails";
import { Grid } from "./grid";
import { EntryType, Menu, MenuEntry } from "./menu";
import { HTTPService, JsonResultClass } from "../util/httpManager";
import { Helper } from "../util/helper";
import { General } from "../../../siteManagement/general";
import { Sheet, SheetEventType } from "../../../siteManagement/sheet";
import { DialogHelper } from "../util/dialogHelper";
import { RightDrawerContainer } from "./rightDrawerContainer";
import { TextBox } from "./textBox";
import { ComponentHelper } from "../util/componentHelper";
import { FieldInstance } from "./field";
import { CheckBox } from "./checkBox";
import { NotificationHelper } from "../util/notificationHelper";
import { FAIcon } from "./faIcon";
import { TabStripProps } from "./tabStrip";
import { Entity, Metadata } from "./commonApp";
import { EventType } from "../../../siteManagement/eventManager";
import React from "react";
export default class Reporting extends React.Component<ReportingProps, { createReportButtonEnabled: boolean, editReportButtonEnabled: boolean, deleteButtonEnable: boolean }>{
    private _contextTypeKey: number;
    private _recordId: number;
    private _pIndex: string;
    private _dataLoaded = false;
    private _gridData = [];
    private _gridOptions: kendo.ui.GridOptions = {
        columns: []
    };
    private _gridSchema = {};
    private _selectWndMenuDataSource: Array<MenuEntry> = [];
    private _availableReportsGridData = [];
    private _availableReportsGridOptions = {};
    private _additionalDataDynamicApiId: { id: string } = null;
    private _additionalDataPlannedReportsDynamicApiId: { id: string } = null;
    private _availableReportsGridSchema = {};
    private _translations = {};
    private _selectReportApp: SelectReport;
    private _dataUrl: string;
    private _topMostSheet: Sheet = null;

    constructor(props: ReportingProps) {
        super(props);
        this.state = { createReportButtonEnabled: true, editReportButtonEnabled: true, deleteButtonEnable: true }
        this._initApp();
        window['fillPlannedReport'] = (id) => {
            const item = this._gridData.filter(itemId => itemId.PlannedReportId == id)[0];
            this.createPlannedReport(item);
        }
        window['openReport'] = (id) => {
            const item = this._gridData.filter(itemId => itemId.ServiceReportId == id)[0];
            this.open(item);
        }


        console.log(props)

    }
    componentWillUnmount = () => {
        delete (window['fillPlannedReport']);
        delete (window['openReport']);
    }
    private _initApp = () => {
        switch (this.props.context.contextType) {
            case "serviceReport":
                this._contextTypeKey = 0;
                break;
            case "address":
                this._contextTypeKey = 1;
                break;
            case "machine":
                this._contextTypeKey = 2;
                break;
            case "ticket":
                this._contextTypeKey = 3;
                break;
            case "project":
                this._contextTypeKey = 4;
                break;
            case "resourcePlanning":
                this._contextTypeKey = 5;
                break;
            default:
                throw new Error("Unknown or unsupported context type for Reporting.");
        }

        this._recordId = this.props.context.keyVal1;
        this._pIndex = this.props.context.keyVal2;
    }

    async componentDidMount() {
        this._topMostSheet = General.Sheet.Manager.getTopMostSheet();
        const result = await Promise.all([
            HTTPService.chainBatch
                .add<Metadata>(Helper.getMetaData('reporting'))
                .add("Reporting/GetAvailableReports")
                .promise(),
            Helper.getTranslations(["WebSMS.Reporting.EditMarkedReport", "WebSMS.Reporting.NewReportFill", "WebSMS.Reporting.SelectReport", "WebSMS.Reporting.EditReport", "Standard.Neu", "Standard.Editieren", "Standard.Loeschen", "Maschine.Maschine", "Maschine.Maschinensuche", "WebSMS.Reporting.AddReport", "WebSMS.Reporting.AddPlannedReport", "WebSMS.Reporting.CreatePlannedReport", "WebSMS.Reporting.Remark", "WebSMS.Reporting.Mandatory"])
        ])
        this._translations = result[1].Data;
        for (let i = 0; i < result[0][0].additional.objects.length; i++) {
            switch (result[0][0].additional.objects[i]["name"]) {
                case "recordReportsGridOptions":
                    //reports associated with the current record
                    this._gridOptions = result[0][0].additional.objects[i]["data"];
                    if (this._contextTypeKey !== 0) {
                        if (Array.isArray(this._gridOptions.columns)) {
                            let idx = -1;
                            for (let j = 0; j < this._gridOptions.columns.length; j++) {
                                if (Helper.hasValue(this._gridOptions.columns[j]) && Helper.hasValue(this._gridOptions.columns[j].field) && this._gridOptions.columns[j].field === "Index") {
                                    idx = j;
                                    break;
                                }
                            }
                            if (idx >= 0) {
                                this._gridOptions.columns.splice(idx, 1);
                            }
                        }
                    }
                    break;
                case "newReportWndMenuDataSource":
                    this._selectWndMenuDataSource = result[0][0].additional.objects[i]["data"];
                    break;
                case "recordReportsAllReportsGridOptions":
                    //all the reports defined in the data base (available for selection/instanciation)
                    this._availableReportsGridOptions = result[0][0].additional.objects[i]["data"];
                    break;
                case "additionalDataDynamicApiId":
                    this._additionalDataDynamicApiId = result[0][0].additional.objects[i]["data"];
                    break;
                case "additionalDataPlannedReportsDynamicApiId":
                    //all the reports defined in the data base (available for selection/instanciation)
                    this._additionalDataPlannedReportsDynamicApiId = result[0][0].additional.objects[i]["data"];
                    break;
                default:
                    break;
            }
        }
        this._availableReportsGridData = result[0][1].Data
        await this._getGridData();
        this._dataLoaded = true;
        this.setState({});

    }

    private async _getGridData() {
        const additionalDataApiId = (this._additionalDataDynamicApiId && this._additionalDataDynamicApiId.id ? ('&additionalDataDynamicApiId=' + this._additionalDataDynamicApiId.id) : '');
        const additionalDataPlannedReportApiId = (this._additionalDataPlannedReportsDynamicApiId && this._additionalDataPlannedReportsDynamicApiId.id ? ('&additionalDataPlannedReportsDynamicApiId=' + this._additionalDataPlannedReportsDynamicApiId.id) : '');
        this._dataUrl = `Reporting/GetReportsForRecord?type=${this._contextTypeKey}&recordId=${encodeURIComponent(this._recordId)}${this.props.context.keyVal2 ? '&pIndex=' + this.props.context.keyVal2 : ''}${additionalDataApiId}${additionalDataPlannedReportApiId}`
        const result = await HTTPService.get(this._dataUrl)
        this._gridData = result.Data;
        this.setState({});
    }

    private _openEditWindow = (reportId, serviceReportId, type, position, machine, recordId, title, pIndex, plannedReportId, remark) => {
        const recordIsguid = this.props.entity["IsGuid"] || this.props.entity["Isguid"];
        const editUrl = 'Reporting/Edit?isWindow=true&reportId=' + encodeURIComponent(reportId) + '&type=' + type + '&serviceReportId=' + (serviceReportId ? serviceReportId : '') + (typeof position === "number" ? '&position=' + position : '') + (machine ? "&machine=" + encodeURIComponent(machine) : "") + (recordId ? "&recordId=" + encodeURIComponent(recordId) : "") + (pIndex ? "&pIndex=" + pIndex : "") + (plannedReportId ? "&plannedReportId=" + plannedReportId : "") + (recordIsguid ? "&recordIsguid=" + recordIsguid : "") + (remark ? "&remark=" + remark : "");

        const sheet = General.Sheet.Manager.createSheetWithUrl(editUrl);
        sheet.setTitle(title);
        sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
            this._getGridData();
        });
    }

    private _createPlannedReportEntry = async (templateids, mandatory, remark, serviceReportId, Maschnr) => {
        const url = "Reporting/CreatePlannedReport?";

        const result = await HTTPService.post<JsonResultClass>(url, { TemplateIds: templateids, Mandatory: mandatory, Remark: remark, ServiceReportId: serviceReportId, Maschnr: Maschnr, ReportType: this._contextTypeKey })
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(result.Message);
            this._getGridData();
            this.triggerRefreshSendState();
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private triggerRefreshSendState = () => {
        this._topMostSheet.trigger(SheetEventType.Custom, { command: "refreshSendState" });
    }

    create = (isPlannedReport: boolean) => {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(this._translations["WebSMS.Reporting.SelectReport"]);
        sheet.show(() => {
            const newReportEntity = {
                IsNew: true,
                RecordRight: this.props.entity.RecordRight,
                Machine: null,
                Address: this.props.entity["Adrnr"] || this.props.entity["AdrNr"] || this.props.entity["Adresse_Key"]
            }

            const props = {
                context: this.props.context,
                isWindow: true,
                menuEntries: this._selectWndMenuDataSource,
                entity: newReportEntity,
                handleEval: this.props.handleEval,
                isPlannedReport: isPlannedReport,
                reportSelected: (reports, Remark, Mandatory, Maschnr) => {
                    sheet.hide();
                    if (isPlannedReport) {
                        this._createPlannedReportEntry(reports.map((i) => i.Id), Mandatory, Remark, this.props.entity["IsGuid"] || this.props.entity["Isguid"], Maschnr);
                    } else {
                        const report = reports[0];
                        this._openEditWindow(report.Id, report.ServiceReportId, this._contextTypeKey, report.Index, props.entity.Machine, this._recordId, this._translations["WebSMS.Reporting.AddReport"], this._pIndex, null, Remark);
                    }
                },
                translations: this._translations,
                availableReports: this._availableReportsGridData,
                gridOptions: this._availableReportsGridOptions,
                metadata: {
                    additional: {
                        objects: {
                            data: {
                                visible: true,
                                width: 400,

                                multipleComponents: [
                                    {
                                        moduleName: "app/core/components/iframe",
                                        iconName: "question-circle",
                                        renderAlways: true,
                                        props: {
                                            url: "{{helpBaseUrl}}/{{helpVersion}}/{{helpLanguage}}/arbeiten-mit-projekten-und-einsaetzen/arbeiten-mit-technischen-berichten/anlegen-eines-technischen-berichts"
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            };
            sheet.mountContent(SelectReport, props as any);//...
        });
    }

    editMachineRemarkMandatory = (dataItem: { PlannedReportId: string, ServiceReportId: string, MachineNumber: string, Mandatory: boolean, Remark: string }) => {
        const isPlannedReport = dataItem.PlannedReportId && !dataItem.ServiceReportId;
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(this._translations["WebSMS.Reporting.SelectReport"]);
        sheet.show(() => {
            const newReportEntity = {
                IsNew: true,
                RecordRight: this.props.entity.RecordRight,
                Machine: dataItem.MachineNumber,
                Address: this.props.entity["Adrnr"] || this.props.entity["AdrNr"] || this.props.entity["Adresse_Key"],
                Mandatory: dataItem.Mandatory,
                Remark: dataItem.Remark,
                PlannedReportId: dataItem.PlannedReportId,
                ServiceReportId: dataItem.ServiceReportId
            }

            const props = {
                context: this.props.context,
                isWindow: true,
                menuEntries: this._selectWndMenuDataSource,
                entity: newReportEntity,
                handleEval: this.props.handleEval,
                isPlannedReport: isPlannedReport,
                translations: this._translations,
                availableReports: this._availableReportsGridData,
                gridOptions: this._availableReportsGridOptions,
                metadata: {
                    additional: {
                        objects: {
                            data: {
                                visible: true,
                                width: 400,

                                multipleComponents: [
                                    {
                                        moduleName: "app/core/components/iframe",
                                        iconName: "question-circle",
                                        renderAlways: true,
                                        props: {
                                            url: "{{helpBaseUrl}}/{{helpVersion}}/{{helpLanguage}}/arbeiten-mit-projekten-und-einsaetzen/arbeiten-mit-technischen-berichten/anlegen-eines-technischen-berichts"
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            };

            sheet.mountContent(EditMachineRemarkMandatory, props as any);//...
        });
        sheet.bind(SheetEventType.Close, (target) => {
            this._getGridData();
        });
    }

    open = (dataItem: any) => {
        this._openEditWindow(dataItem.Id, dataItem.ServiceReportId, this._contextTypeKey, dataItem.Index, dataItem.MachineNumber, this._recordId, this._translations["WebSMS.Reporting.EditReport"], this._pIndex, null, dataItem.Remark);
    }

    createPlannedReport = (dataItem: any) => {
        this._openEditWindow(dataItem.Id, null, this._contextTypeKey, null, dataItem.MachineNumber, this._recordId, this._translations["WebSMS.Reporting.EditReport"], this._pIndex, dataItem.PlannedReportId, dataItem.Remark);
    }

    remove = async (dataItem) => {
        const isOK = await DialogHelper.confirm(this.props.translations["Standard.Msg.Loeschen"])
        if (isOK) {
            let url = "";
            if (Helper.hasValue(dataItem.ServiceReportId)) {
                url = 'Reporting/Remove?reportId=' + dataItem.Id + '&serviceReportId=' + dataItem.ServiceReportId + '&type=' + this._contextTypeKey + '&position=' + dataItem.Index + (this._recordId ? "&recordId=" + this._recordId : "")
            } else {
                url = 'Reporting/RemovePlannedReport?plannedReportId=' + dataItem.PlannedReportId;
            }

            const result = await HTTPService.get(url);
            this._getGridData();

            if (result.Code != 0) {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.NEW) {
            this.create(false);
        } else if (type === ToolBarStandardButtonType.EDIT) {
            this.open(dataItem);
        } else if (type == ToolBarStandardButtonType.DELETE) {
            this.remove(dataItem);
        }
    }
    handleClickCustomButton = (id: string, dataItem: any) => {
        if (id === "PlannedReport") {
            this.create(true);
        } else if (id === "CreateReportFromPlannedReport") {
            this.createPlannedReport(dataItem);
        }
        else if (id === "EditMaschineRemarkMandatory") {
            this.editMachineRemarkMandatory(dataItem);
        }
    }

    private _onSelectionChanged = (dataItem: { PlannedReportId: string, IsPlannedReport: boolean, CompletedByDispatcher: boolean, CompletedByTechnician: boolean }) => {
        if (Helper.hasValue(dataItem))
            this.setState({ createReportButtonEnabled: !Helper.isNullOrEmpty(dataItem.PlannedReportId), editReportButtonEnabled: !dataItem.IsPlannedReport, deleteButtonEnable: !dataItem.CompletedByDispatcher && !dataItem.CompletedByTechnician });
    }

    private getGridData = () => {
        const data: any[] = JSON.parse(JSON.stringify(this._gridData))
        for (let i = 0; i < data.length; i++) {
            const item = data[i];
            const machineName = item.Maschbezeichnung;
            const machineNo = item.MachineNumber;

            let template = "";
            if (!Helper.isNullOrEmpty(machineName) && !Helper.isNullOrEmpty(machineNo)) {
                template = `${machineName}(${machineNo})`
            } else if(!Helper.isNullOrEmpty(machineNo)){
                template = machineNo
            }

            data[i].MachineTemplate = template;


        }
        return data;
    }

    private getButtons = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        const customButtons: Array<GridCustomToolBarButton> = [];


        const readonly = this._contextTypeKey === 5 && !this.props.entity["ReportAcquisition"]

        if (!readonly) {
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: this._translations["WebSMS.Reporting.NewReportFill"], enabled: this.props.entity.RecordRight["CanCreateChecklist"] && this.props.entity.RecordRight.CanWrite });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: this._translations["WebSMS.Reporting.EditMarkedReport"], enabled: this.props.entity.RecordRight["CanCreateChecklist"] && this.state.editReportButtonEnabled && this.props.entity.RecordRight.CanWrite });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: this._translations["Standard.Loeschen"], enabled: this.props.entity.RecordRight["CanCreateChecklist"] && this.props.entity.RecordRight.CanWrite && (this.state.deleteButtonEnable || this.props.entity.RecordRight["CanDeleteCompletedReports"]) });

            if (this.props.entity.RecordRight["CanAddPlannedReport"]) {
                customButtons.push({
                    autoEnabledOnRecordSelected: false,
                    caption: this._translations["WebSMS.Reporting.AddPlannedReport"],
                    enabled: this.props.entity.RecordRight.CanWrite,
                    id: "PlannedReport",
                    iconClass: "k-i-add"
                });
            }
            customButtons.push({
                autoEnabledOnRecordSelected: true,
                caption: this._translations["WebSMS.Reporting.CreatePlannedReport"],
                enabled: this.props.entity.RecordRight["CanCreateChecklist"] && this.state.createReportButtonEnabled && this.props.entity.RecordRight.CanWrite,
                id: "CreateReportFromPlannedReport",
                iconClass: "k-i-add",
                useContextMenu: true
            });

            customButtons.push({
                autoEnabledOnRecordSelected: true,
                caption: Helper.getTranslation("Standard.Editieren"),
                enabled: this.state.deleteButtonEnable && this.props.entity.RecordRight.CanWrite,
                id: "EditMaschineRemarkMandatory",
                iconClass: "k-i-add",
                useContextMenu: true
            });
        }


        return { customButtons, standardButtons }
    }

    render() {
        let content = null;
        if (this._dataLoaded) {
            const { customButtons, standardButtons } = this.getButtons();
            content = <Grid data={this.getGridData()} options={this._gridOptions} id={"reporting-" + this.props.context.contextType}
                standardButtons={standardButtons} customButtons={customButtons} onClickCustomButton={this.handleClickCustomButton} onClickStandardButton={this.handleClickStandardButton}
                onSelectionChanged={this._onSelectionChanged}
                gridDetails={{
                    useFeature: true
                }}
                useFloatingButtons={true}
            />
        }

        return (content);
    }
}


export class SelectReport extends React.Component<any, SelectReportState>{
    common = new AppHelper();
    selectReportEnabled = false;
    private _rightDrawerContainer: any;
    private _factory = ComponentHelper.createFactory();
    private modifiedGridOptions;

    constructor(props) {
        super(props);
        let metaDataAdditional = this.props.metadata.additional.objects.data;
        this._rightDrawerContainer = metaDataAdditional;
        this.common.init(this);
        this.common.unloadHelper.disable();
        this.state = {
            Remark: "",
            Mandatory: false,
            SelectedReports: []
        };
        this.modifiedGridOptions = JSON.parse(JSON.stringify(props.gridOptions));
        if (this.props.isPlannedReport) {
            this.modifiedGridOptions.selectable = "multiple, row";
        }
        else {
            this.modifiedGridOptions.columns[0].reactTemplate = this.reactTemplate;
        }
        this.modifiedGridOptions.filterable = true;
    }

    private reactTemplate = (dataItem) => {
        return <a onClick={() => this.onReportSelected(dataItem)}>{dataItem.Description}</a>
    }

    private onReportSelected = (dataItem) => {
        this.props.reportSelected([dataItem], this.state.Remark, this.state.Mandatory, this.props.entity.Machine)
    }

    private _renderRightDrawerComponent = () => {
        if (this._rightDrawerContainer !== null) {
            let entity: Entity = {
                IsNew: true,
                RecordRight: {
                    CanRead: true, CanWrite: true
                },
                IsWatchable: false,
                IsWatched: false
            };

            return <RightDrawerContainer
                moduleName={this._rightDrawerContainer.moduleName}
                appName={this._rightDrawerContainer.appName}
                visible={this._rightDrawerContainer.visible}
                width={this._rightDrawerContainer.width}
                customProps={this._rightDrawerContainer.props}
                entity={entity}
                renderAlways={this._rightDrawerContainer.renderAlways}
                multipleComponents={this._rightDrawerContainer.multipleComponents}
            />
        }
        return null;
    }

    reportSelected = (reports) => {
        let newSelected = [];
        if (Array.isArray(reports)) {
            newSelected = reports;
        } else if (reports !== null) {
            newSelected = [reports];
        }
        this.setState({ SelectedReports: newSelected });

        if (!this.props.isPlannedReport && Helper.useMobileGui()) {
            this.onReportSelected(reports);
        }
    }
    private _onChange = (field, value) => {
        if (field.model === "entity.Remark") {
            this.setState({
                ...this.state, Remark: value
            });
        } else if (field.model === "entity.Mandatory") {
            this.setState({
                ...this.state, Mandatory: value
            });
        }
    }

    

    render() {
        const value = this.props.entity.Machine;
        const field: IsSearchFieldField = {
            visible: true,
            type: "is-search-field",
            required: false,
            model: "entity.Machine",
            name: this.props.translations["Maschine.Maschine"],
            readOnly: false,
            searchWindowUrlParameterName: "adrnr",
            listWidth: 650,
            searchWindowUrlParameterModel: "entity.Address",
            autocompleteEnabled: true,
            autocompleteTemplate: "<table cellspacing='0' style='table-layout:fixed; width:650px'><colgroup><col style='width: 100px' /><col style='width: 250px' /><col style='width: 300px' /></colgroup><tr style='background-color:# if(data.Status == 1) { #\\#cccccc# } else { #inherit# } #'><td style='vertical-align:top; word-wrap: break-word'>${data.MaschNr}</td># if(data.MaschBezeichnung != null) { #<td style='vertical-align:top'>${data.MaschBezeichnung}</td>#}else{#<td style='vertical-align:top'></td>#}#<td style='vertical-align:top'>${data.AdrName}</td></tr></table>",
            autocompleteUrl: "MachineLookup/Find",
            autocompleteDataTextField: "MaschNr",
            autocompleteAdditionalFilterParameterName: "adrNr",
            autocompleteAdditionalFilterParameter: "entity.Address",
            searchButtonEnabled: true,
            searchWindowTitle: this.props.translations["Maschine.Maschinensuche"],
            searchWindowUrl: "DynamicSearch/Window/Machine"
        };
        return (
            
            <>
                {this.props.isPlannedReport ? <Menu entries={[
                    { text: this.props.translations["WebSMS.Reporting.AddPlannedReport"], onClick: () => { this.props.reportSelected(this.state.SelectedReports, this.state.Remark, this.state.Mandatory, this.props.entity.Machine) }, show: this.state.SelectedReports && this.state.SelectedReports.length > 0, floating: true }
                ]} onSelect={() => { }} enableMenuItem={() => true} handleEval={() => { }} /> : null}

                {this._renderRightDrawerComponent()}
                <div className="flex-container reporting-container">
                    <div className=" flex-container flex-container--item">
                        <ReportParams field={field}
                            value={value}
                            remark={this.state.Remark}
                            onChange={this._onChange}
                            translations={this.props.translations}
                            mandatory={this.state.Mandatory}
                            context={this.props.context}
                            handleIsSearchFieldFullObjectModel={this.props.handleIsSearchFieldFullObjectModel}
                            handleFieldChange={this.common.handleFieldChange}
                            evalAction={this.common.evalAction}
                            isPlannedReport={this.props.isPlannedReport}
                        />
                        <div className="flex-container__item" style={{ marginTop: 5 }}>
                            <Grid data={this.props.availableReports} options={this.modifiedGridOptions} onSelectionChanged={this.reportSelected} id="reportingMachines" />
                        </div>
                    </div>
                </div>
            </>);
    }
}

class EditMachineRemarkMandatory extends React.Component<any, any>{
    common = new AppHelper();
    selectReportEnabled = false;
    private _rightDrawerContainer: any;

    constructor(props) {
        super(props);
        let metaDataAdditional = this.props.metadata.additional.objects.data;
        this._rightDrawerContainer = metaDataAdditional;
        this.common.init(this);
        this.common.unloadHelper.disable();
    }

    private _renderRightDrawerComponent = () => {
        if (this._rightDrawerContainer !== null) {
            let entity: Entity = {
                IsNew: true,
                RecordRight: {
                    CanRead: true, CanWrite: true
                },
                IsWatchable: false,
                IsWatched: false
            };

            return <RightDrawerContainer
                moduleName={this._rightDrawerContainer.moduleName}
                appName={this._rightDrawerContainer.appName}
                visible={this._rightDrawerContainer.visible}
                width={this._rightDrawerContainer.width}
                customProps={this._rightDrawerContainer.props}
                entity={entity}
                renderAlways={this._rightDrawerContainer.renderAlways}
                multipleComponents={this._rightDrawerContainer.multipleComponents}
            />
        }
        return null;
    }
    save = async () => {
        const url = "Reporting/ChangeMachineRemarkMandatory?";
        const result = await HTTPService.post<JsonResultClass>(url, { Maschnr: this.props.entity.Machine, Mandatory: this.props.entity.Mandatory, Remark: this.props.entity.Remark, ServiceReportId: this.props.entity.ServiceReportId, PlannedReportId: this.props.entity.PlannedReportId })
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(result.Message);
            General.Sheet.Manager.getTopMostSheet().hide();
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }
    render() {
        const field: IsSearchFieldField = {
            visible: true,
            type: "is-search-field",
            required: false,
            model: "entity.Machine",
            name: this.props.translations["Maschine.Maschine"],
            readOnly: false,
            searchWindowUrlParameterName: "adrnr",
            listWidth: 650,
            searchWindowUrlParameterModel: "entity.Address",
            autocompleteEnabled: true,
            autocompleteTemplate: "<table cellspacing='0' style='table-layout:fixed; width:650px'><colgroup><col style='width: 100px' /><col style='width: 250px' /><col style='width: 300px' /></colgroup><tr style='background-color:# if(data.Status == 1) { #\\#cccccc# } else { #inherit# } #'><td style='vertical-align:top; word-wrap: break-word'>${data.MaschNr}</td># if(data.MaschBezeichnung != null) { #<td style='vertical-align:top'>${data.MaschBezeichnung}</td>#}else{#<td style='vertical-align:top'></td>#}#<td style='vertical-align:top'>${data.AdrName}</td></tr></table>",
            autocompleteUrl: "MachineLookup/Find",
            autocompleteDataTextField: "MaschNr",
            autocompleteAdditionalFilterParameterName: "adrNr",
            autocompleteAdditionalFilterParameter: "entity.Address",
            searchButtonEnabled: true,
            searchWindowTitle: this.props.translations["Maschine.Maschinensuche"],
            searchWindowUrl: "DynamicSearch/Window/Machine"
        };
        return (
            <>
                <Menu entries={[
                    { type: EntryType.Save, onClick: () => { this.save(); } }
                ]} onSelect={() => { }} enableMenuItem={() => true} handleEval={this.common.evalAction} />

                {this._renderRightDrawerComponent()}
                <div className="flex-container">
                    <div className=" flex-container flex-container--item">
                        <ReportParams field={field}
                            value={this.props.entity.Machine}
                            remark={this.props.entity.Remark}
                            onChange={this.common.handleFieldChange}
                            translations={this.props.translations}
                            mandatory={this.props.entity.Mandatory}
                            context={this.props.context}
                            handleIsSearchFieldFullObjectModel={this.props.handleIsSearchFieldFullObjectModel}
                            handleFieldChange={this.common.handleFieldChange}
                            evalAction={this.common.evalAction}
                            isPlannedReport={this.props.isPlannedReport}
                        />
                    </div>
                </div>
            </>);
    }
}

function ReportParams(props: { field, value, translations, onChange, remark, mandatory, context, handleIsSearchFieldFullObjectModel, handleFieldChange, evalAction, isPlannedReport }) {
    const _factory = ComponentHelper.createFactory();
    const textboxRemarksProps = _factory.getDefaultTextBoxProps();
    textboxRemarksProps.field.name = props.translations["WebSMS.Reporting.Remark"];
    textboxRemarksProps.field.labelAndControlCombined = true;
    textboxRemarksProps.field.model = "entity.Remark";
    textboxRemarksProps.value = props.remark;
    textboxRemarksProps.field.multiLine = true;
    textboxRemarksProps.field.triggerOnChange = true;
    textboxRemarksProps.onChange = props.onChange;
    if (Helper.useMobileGui())
        textboxRemarksProps.textAreaHeight = "10rem";

    const checkboxProps = _factory.getDefaultCheckBoxProps();
    checkboxProps.field.model = "entity.Mandatory";
    checkboxProps.field.name = props.translations["WebSMS.Reporting.Mandatory"];
    checkboxProps.value = props.mandatory;
    checkboxProps.onChange = props.onChange;
    const panelBarField = {
        visible: true,
        type: "is-panelbar-details",
        model: "entity.Machine",
        url: "MachineLookup/MachineHeader",
        template: "MachineDetails"
    };
    return <>
        <div style={{ marginTop: 10, marginBottom: 10, display: "flex", flexWrap: "wrap", alignItems: "center" }}>
            <label style={{ marginLeft: "5px" }}>{props.field.name}</label>
            <div style={{ flex: "1", margin: "5px" }}>
                <IsSearchField field={props.field} value={props.value} context={props.context} commandManager={null}
                    onChange={props.handleFieldChange} handleEval={props.evalAction} handleIsSearchFieldFullObjectModel={props.handleIsSearchFieldFullObjectModel}
                    multiSelectMode={false} disabled={false} />
            </div>
        </div>
        <IsPanelbarDetails field={panelBarField} commandManager={null} onDataLoaded={() => { }} value={props.value} />
        <FieldInstance label={props.translations["WebSMS.Reporting.Remark"]} noHover={true}>
            <TextBox {...textboxRemarksProps} />
        </FieldInstance>
        {props.isPlannedReport ?
            <FieldInstance label={props.translations["WebSMS.Reporting.Mandatory"]} noHover={true}>
                <CheckBox{...checkboxProps} />
            </FieldInstance>
            : null}
    </>
}
interface SelectReportState {
    Remark: string,
    Mandatory: boolean,
    SelectedReports: any[]
}

interface ReportingProps extends TabStripProps {
}